import { render, staticRenderFns } from "./AddDrawer.vue?vue&type=template&id=6c107a5e&scoped=true"
import script from "./AddDrawer.vue?vue&type=script&lang=js"
export * from "./AddDrawer.vue?vue&type=script&lang=js"
import style0 from "./AddDrawer.vue?vue&type=style&index=0&id=6c107a5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c107a5e",
  null
  
)

export default component.exports